import React from 'react';
const FundingAnalysisContext = React.createContext();
FundingAnalysisContext.displayName = 'Funding Analysis Context';
export default FundingAnalysisContext;
